export const COMPANY_ADMIN_SIDEBAR_GROUPS = [
  {
    id: 'workspace',
    items: [
      { id: 'company-portfolio', label: 'Portfolio', icon: 'bi-briefcase', route_name: 'CommandCentre' },
      { id: 'company-cases', label: 'Onboardings', icon: 'bi-folder2-open', route_name: 'CompanyCases' },
      { id: 'company-inbox', label: 'Inbox', icon: 'bi-inboxes', route_name: 'CompanyInbox' },
      { id: 'company-messages', label: 'Messages', icon: 'bi-chat-dots', route_name: 'CompanyMessages' },
      { id: 'panel-register', label: 'Panel Register', icon: 'bi-people', route_name: 'PanelRegister' },
      { id: 'qa-review', label: 'QA Review', icon: 'bi-clipboard-check', route_name: 'QAReview' },
      { id: 'time-sheets', label: 'Timesheets', icon: 'bi-clock-history', route_name: 'TimeSheets' },
      { id: 'audit-log', label: 'Audit Log', icon: 'bi-journal-text', route_name: 'AuditLog' },
      { id: 'company-reports', label: 'Reports', icon: 'bi-bar-chart', route_name: 'CompanyReports' },
      { id: 'tenant-settings', label: 'Tenant Settings', icon: 'bi-sliders', route_name: 'TenantSettings' }
    ]
  }
];

export const CASE_OWNER_WORK_ITEMS = [
  { id: 'owner-overview', label: 'Overview', icon: 'bi-grid-3x3-gap', route_name: 'OwnerDashboard', count: null },
  { id: 'owner-all-cases', label: 'All onboardings', icon: 'bi-file-earmark', route_name: 'OwnerQueue', count: '142' },
  { id: 'owner-inbox', label: 'Inbox', icon: 'bi-file-earmark', route_name: 'OwnerInbox', count: '23' },
  { id: 'owner-messages', label: 'Messages', icon: 'bi-person', route_name: 'OwnerMessages', count: '5' },
  { id: 'owner-calendar', label: 'Calendar', icon: 'bi-clock', route_name: 'OwnerCalendar', count: null },
  { id: 'owner-time-entry', label: 'Time entry', icon: 'bi-clock', route_name: 'OwnerTimeEntry', count: null },
  { id: 'owner-reports', label: 'Reports', icon: 'bi-bar-chart', route_name: 'OwnerReports', count: null }
];

export const CASE_OWNER_STATUS_ITEMS = [
  { id: 'status-decisions-due', label: 'Decisions due', route_name: 'OwnerQueue', route_query: { status: 'decisions-due' }, count: '3', dot_class: 'is-danger' },
  { id: 'status-in-review', label: 'In review', route_name: 'OwnerQueue', route_query: { status: 'in-review' }, count: '8', dot_class: 'is-success' },
  { id: 'status-pending-evidence', label: 'Pending evidence', route_name: 'OwnerQueue', route_query: { status: 'pending-evidence' }, count: '24', dot_class: 'is-warning' },
  { id: 'status-in-progress', label: 'In progress', route_name: 'OwnerQueue', route_query: { status: 'in-progress' }, count: '92', dot_class: 'is-success' },
  { id: 'status-closed-30d', label: 'Closed (30d)', route_name: 'OwnerQueue', route_query: { status: 'closed-30d' }, count: '15', dot_class: 'is-muted' }
];

export const REQUESTOR_WORK_ITEMS = [
  { id: 'requestor-overview', label: 'Overview', icon: 'bi-grid-3x3-gap', route_name: 'RequestorDashboard', count: null },
  { id: 'requestor-all-cases', label: 'All onboardings', icon: 'bi-file-earmark', route_name: 'OwnerQueue', count: '142' },
  { id: 'requestor-inbox', label: 'Inbox', icon: 'bi-file-earmark', route_name: 'OwnerInbox', count: '23' },
  { id: 'requestor-messages', label: 'Messages', icon: 'bi-person', route_name: 'OwnerMessages', count: '5' },
  { id: 'requestor-calendar', label: 'Calendar', icon: 'bi-clock', route_name: 'OwnerCalendar', count: null },
  { id: 'requestor-time-entry', label: 'Time entry', icon: 'bi-clock', route_name: 'OwnerTimeEntry', count: null },
  { id: 'requestor-reports', label: 'Reports', icon: 'bi-bar-chart', route_name: 'OwnerReports', count: null }
];

export const COORDINATOR_WORK_ITEMS = [
  { id: 'coordinator-dashboard', label: 'Scope dashboard', icon: 'bi-grid-3x3-gap', route_name: 'ScopeDashboard', count: null },
  { id: 'coordinator-cases', label: 'Onboardings in scope', icon: 'bi-file-earmark', route_name: 'CompanyCases', count: '684' },
  { id: 'coordinator-inbox', label: 'Inbox', icon: 'bi-file-earmark', route_name: 'CompanyInbox', count: '11' },
  { id: 'coordinator-messages', label: 'Messages', icon: 'bi-person', route_name: 'CompanyMessages', count: '4' },
  { id: 'coordinator-calendar', label: 'Calendar', icon: 'bi-clock', route_name: 'OwnerCalendar', count: null },
  { id: 'coordinator-panel', label: 'Assigned panel', icon: 'bi-person', route_name: 'PanelRegister', count: '12' },
  { id: 'coordinator-timesheets', label: 'Timesheets', icon: 'bi-clock', route_name: 'TimeSheets', count: '3' },
  { id: 'coordinator-reports', label: 'Scope reports', icon: 'bi-bar-chart', route_name: 'CompanyReports', count: null }
];

export const ONBOARDING_SYSTEM_GROUPS = [
  {
    id: 'overview',
    label: 'Overview',
    items: [
      { id: 'command-centre', label: 'Command centre', icon: 'bi-grid', route_name: 'CommandCentre', count: 'Live', tone: 'neutral' },
      { id: 'my-queue', label: 'My queue', icon: 'bi-list-check', route_name: 'MyQueue', count: '142', tone: 'neutral' },
      { id: 'templates', label: 'Templates', icon: 'bi-diagram-3', route_name: 'ManageTemplates', count: null, tone: 'neutral' }
    ]
  },
  { id: 'gates', label: 'Gates', items: [] },
  { id: 'journeys', label: 'Journeys', items: [] },
  {
    id: 'insight',
    label: 'Insight',
    items: [
      { id: 'reports', label: 'Reports', icon: 'bi-file-earmark-text', route_name: 'OnboardingManageReports', count: null, tone: 'neutral' },
      { id: 'complyon-sync', label: 'Complyon sync', icon: 'bi-box-arrow-up-right', route_name: 'OnboardingComplyonSync', count: null, tone: 'neutral' },
      { id: 'audit-log', label: 'Audit log', icon: 'bi-archive', route_name: 'OnboardingAuditLog', count: null, tone: 'neutral' }
    ]
  }
];

export const APPLICANT_ONBOARDING_GROUPS = [
  {
    id: 'applicant-overview',
    label: 'Onboarding',
    items: [
      { id: 'my-onboardings', label: 'My onboardings', icon: 'bi-list-check', route_name: 'MyQueue', count: '0', tone: 'neutral' }
    ]
  }
];

export const EMPTY_ONBOARDING_BADGES = {
  'my-queue': '0',
  'all-journeys': '0'
};

export const ONBOARDING_JOURNEY_ROUTE_BY_KEY = new Map([
  ['supplier', 'ManageSupplier'],
  ['employee', 'ManageEmployees'],
  ['employees', 'ManageEmployees'],
  ['merchant', 'ManageClient'],
  ['partner', 'ManagePartner'],
  ['intern', 'ManageIntern'],
  ['client', 'ManageClient']
]);

export const ONBOARDING_JOURNEY_ICON_BY_KEY = new Map([
  ['supplier', { icon: 'bi-truck', icon_tone: 'navy' }],
  ['employee', { icon: 'bi-people', icon_tone: 'teal' }],
  ['employees', { icon: 'bi-people', icon_tone: 'teal' }],
  ['merchant', { icon: 'bi-shop', icon_tone: 'warning' }],
  ['partner', { icon: 'bi-link-45deg', icon_tone: 'rose' }],
  ['intern', { icon: 'bi-mortarboard', icon_tone: 'purple' }],
  ['client', { icon: 'bi-building', icon_tone: 'green' }]
]);

export const GATE_ROUTE_CONFIG = new Map([
  ['applicant', { route_name: 'OnboardingGateStatusQueue', route_query: { status: 'Applicant' }, icon: 'bi-file-earmark-text', tone: 'success' }],
  ['draft', { route_name: 'OnboardingGateStatusQueue', route_query: { status: 'Draft' }, icon: 'bi-signpost-2', tone: 'neutral' }],
  ['submitted', { route_name: 'OnboardingGateStatusQueue', route_query: { status: 'Submitted' }, icon: 'bi-signpost-2', tone: 'neutral' }],
  ['approved', { route_name: 'OnboardingGateStatusQueue', route_query: { status: 'Approved' }, icon: 'bi-check-circle', tone: 'success' }],
  ['rejected', { route_name: 'OnboardingGateStatusQueue', route_query: { status: 'Rejected' }, icon: 'bi-x-circle', tone: 'danger' }],
  ['documents', { route_name: 'OnboardingManageDocuments', icon: 'bi-file-earmark-text', tone: 'danger' }],
  ['field-verification', { route_name: 'OnboardingManageVerification', icon: 'bi-shield-check', tone: 'warning' }],
  ['verification', { route_name: 'OnboardingManageVerification', icon: 'bi-shield-check', tone: 'warning' }],
  ['manual-verification', { route_name: 'OnboardingManageManualVerification', icon: 'bi-shield', tone: 'warning' }],
  ['risk-review', { route_name: 'OnboardingRiskReview', icon: 'bi-exclamation-triangle', tone: 'danger' }],
  ['approvals', { route_name: 'OnboardingManageApprovals', icon: 'bi-hammer', tone: 'warning' }],
  ['contracts', { route_name: 'OnboardingManageAgreements', icon: 'bi-folder', tone: 'warning' }],
  ['e-signing', { route_name: 'OnboardingEsigningSetup', icon: 'bi-pen', tone: 'warning' }],
  ['esigning', { route_name: 'OnboardingEsigningSetup', icon: 'bi-pen', tone: 'warning' }],
  ['training', { route_name: 'OnboardingManageTraining', icon: 'bi-mortarboard', tone: 'warning' }],
  ['activation', { route_name: 'OnboardingManageActivation', icon: 'bi-play', tone: 'success' }]
]);

export const DEFAULT_GATE_ROUTE_CONFIG = {
  route_name: 'OnboardingGateStatusQueue',
  icon: 'bi-signpost-2',
  tone: 'neutral'
};

export const DEFAULT_JOURNEY_ICON_CONFIG = { icon: 'bi-diagram-3', icon_tone: 'navy' };

export const GATE_ROUTE_ALIASES = [
  { match: (value) => value.includes('applicant') || value.includes('intake'), gate_id: 'applicant' },
  { match: (value) => value === 'draft' || value.includes('draft'), gate_id: 'draft' },
  { match: (value) => value === 'submitted' || value.includes('submitted'), gate_id: 'submitted' },
  { match: (value) => value.includes('approved') || value.includes('approve'), gate_id: 'approved' },
  { match: (value) => value.includes('rejected') || value.includes('reject'), gate_id: 'rejected' },
  { match: (value) => value.includes('document'), gate_id: 'documents' },
  { match: (value) => value.includes('field') && value.includes('verif'), gate_id: 'field-verification' },
  { match: (value) => value.includes('manual') && value.includes('verif'), gate_id: 'manual-verification' },
  { match: (value) => value.includes('auto') && value.includes('verif'), gate_id: 'verification' },
  { match: (value) => value.includes('verif'), gate_id: 'verification' },
  { match: (value) => value.includes('risk') || (value.includes('policy') && value.includes('rule')), gate_id: 'risk-review' },
  { match: (value) => ['approval', 'approvals'].includes(value), gate_id: 'approvals' },
  { match: (value) => value.includes('contract') || value.includes('agreement'), gate_id: 'contracts' },
  { match: (value) => value.includes('e-sign') || value.includes('esign') || (value.includes('sign') && value.includes('electronic')), gate_id: 'e-signing' },
  { match: (value) => value.includes('train'), gate_id: 'training' },
  { match: (value) => value.includes('activ'), gate_id: 'activation' }
];
